import { Avatar, Button, Card, Col, Row } from 'antd';
import { useContext, useEffect, useState } from 'react';

import { SidebarContext } from '../../../layouts/Technician/index';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import styles from './index.module.scss';

const Job = (props: any) => {
  const { setCurrentItem, setCurrentPage } = useContext(SidebarContext);
  const [jobDetail, setJobDetail] = useState<any>();
  const [categoryName, setCategoryName] = useState<String>();
  const [loading, setLoading] = useState<Boolean>(true);
  const orderId = props;

  const categories = [
    {
      label: 'ระบบไฟฟ้า',
      value: 'electrical',
    },
    {
      label: 'ระบบประปา',
      value: 'water',
    },
    {
      label: 'งานปูน/พื้น/กระเบื้อง',
      value: 'floor',
    },
    {
      label: 'งานเหล็ก/อลูมิเนียม/ไม้',
      value: 'aluminium',
    },
    {
      label: 'งานฝ้า/หลังคา',
      value: 'ceiling',
    },
    {
      label: 'งานทาสี',
      value: 'paint',
    },
    {
      label: 'ผู้รับเหมา',
      value: 'contractor',
    },
    {
      label: 'ออกแบบ/สถาปนิก',
      value: 'architect',
    },
  ];

  const getJobDetail = async () => {
    try {
      const { data } = await axios.get(
        `/order-service-jobs/orderNo/${orderId?.orderId}`
      );
      setJobDetail(data?.data[0]);
      const categoryMapping = categories.filter(
        (cat) => cat.value === data?.data[0].category
      );
      console.log(categoryMapping);
      setCategoryName(categoryMapping[0].label);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (orderId.orderId) {
      setCurrentItem(orderId.orderId);
      setCurrentPage('jobs-detail');
      getJobDetail();
    }
  }, [orderId?.orderId]);

  return (
    <>
      <Card
        title={
          <Row justify='start' gutter={[32, 32]}>
            <Col>
              <Avatar
                size={{
                  xs: 64,
                  sm: 64,
                  md: 64,
                  lg: 64,
                  xl: 80,
                  xxl: 100,
                }}
                icon={<UserOutlined />}
              />
            </Col>
            <Col>
              <h3>{jobDetail?.customer?.name}</h3>
              <img src='/images/serviceJob/icon-phone-blue.svg'></img>
              <span className={styles.label_phone}>
                {jobDetail?.customer?.phone}
              </span>
            </Col>
          </Row>
        }
        bordered={false}
        style={{ width: '100%' }}
      >
        <div>
          <div className={styles.label_order_id}>
            <span style={{ color: '#045DE9' }}>#{orderId.orderId}</span>
            <span style={{ color: 'black', paddingLeft: '5px' }}>
              {categoryName}
            </span>
          </div>
          <div>
            <Row className={styles.row_detail}>
              <Col span={7} className={styles.title}>
                ชื่อ - สกุลผู้ติดต่อ
              </Col>
              <Col className={styles.detail}>{jobDetail?.customer.name}</Col>
            </Row>
            <Row className={styles.row_detail}>
              <Col span={7} className={styles.title}>
                เบอร์โทรศัพท์
              </Col>
              <Col className={styles.label_phone}>
                {jobDetail?.customer.phone}
              </Col>
            </Row>
            <Row className={styles.row_detail}>
              <Col span={7} className={styles.title}>
                ที่อยู่
              </Col>
              <Col className={styles.detail}>
                {jobDetail?.customer.address} {jobDetail?.customer.province}{' '}
                {jobDetail?.customer.district} {jobDetail?.customer.subDistrict}{' '}
                {jobDetail?.customer.postCode}
              </Col>
            </Row>
            <Row className={styles.row_detail}>
              <Col span={7} className={styles.title}>
                รายละเอียด(เพิ่มเติม)
              </Col>
              <Col className={styles.detail}>{jobDetail?.description}</Col>
            </Row>
            <Row className={styles.row_detail}>
              <Col
                span={7}
                className={styles.detail}
                style={{ marginTop: '10px' }}
              >
                รายละเอียดงาน
              </Col>
            </Row>
            <Row className={styles.row_detail}>
              <Col span={7} className={styles.title}>
                ชื่องาน
              </Col>
              <Col className={styles.detail}>
                งาน{categoryName}
                บ้านคุณ{jobDetail?.customer.name}
              </Col>
            </Row>
          </div>
        </div>
        <div style={{ margin: '10px 0px' }}>
          <Button className={styles.btn_done_job}>
            ประเมินหน้างานเสร็จสิ้น
          </Button>
        </div>
        <hr style={{ border: '1px solid #D9D9D9' }} />
        <div style={{ marginTop: '5%' }}>
          <Row>
            <Col
              span={12}
              style={{
                fontSize: '18px',
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <span>ราคาค่าประเมินงาน</span>
            </Col>
            <Col span={12}>
              <span className={styles.span_total}>
                <span>ยอดชำระ</span>
                <span
                  style={{
                    marginLeft: '20px',
                    fontWeight: 'bold',
                    fontSize: '18px',
                  }}
                >
                  $500
                </span>
              </span>
            </Col>
          </Row>
        </div>
      </Card>
    </>
  );
};

export default Job;
